import React, { Component } from 'react';
import CustomButton from 'components/CustomButton';
import cn from 'classnames';
import Error from 'components/ErrorMessage';
// import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import TextField from 'components/TextField';

import renderIf from 'render-if';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import FullScreenLoader from 'components/FullScreenLoader';
import Tiles from '../../containers/Admin/components/UserAthelete';
// import Tiles from '../../containers/Admin/components/StudentView/components/Tiles';
import styles from './SearchUserByFullName.scss';

class SearchUserByFullName extends Component {
  static propTypes = {
    SearchAtheleteByName: PropTypes.func.isRequired,
    searchEsUserData: PropTypes.shape().isRequired, // eslint-disable-line
    searchEsUserRequested: PropTypes.bool.isRequired,
    // IsLoading: PropTypes.bool.isRequired,
    // userType: PropTypes.string.isRequired,
    // catchUserInfo: PropTypes.func.isRequired,
    // writeCollegeName: PropTypes.func,
    // searchEsHappened: PropTypes.bool.isRequired, // eslint-disable-line
    esError: PropTypes.string.isRequired, // eslint-disable-line
    // filterBasedEsStudents: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    fieldHeader: undefined,
    label: undefined,
    searchSchools: () => {},
    writeCollegeName: () => {},
  };
  constructor(props) {
    super(props);
    this.state = {
      firstname: '',
      lastname: '',
      firstNameErrorMessage: '',
      lastNameErrorMessage: '',
      username: '',
      errorMessage: '',
      name: '',
      student_id: '',
      key: '',
      email: undefined,
      school: '',
      evaluationText: '',
      overrideDivision: '',
      t40: '',
      squats: '',
      bench: '',
      primaryOff: '',
      primaryDef: '',
      secondaryOff: '',
      secondaryDef: '',
      id: '',
      studentfullname: '',
      // fullNames: [],
      // fullnameoncontact: '',
      filterStudentByName: List(),
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.searchEsUserData && nextProps.searchEsUserData.size === 0 &&
       nextProps.searchEsUserRequested === false) {
      this.setState({ errorMessage: 'User not found.' });
    }
    if (nextProps.searchEsUserData && nextProps.searchEsUserData.size > 0) {
      // const total = nextProps.filterBasedEsStudents.get('hits').get('total');
      // const hits = [];
      // if (total > 0) {
        // let results = nextProps.filterBasedEsStudents.get('hits');
        // results = results.get('hits');
        // results = results.toJS();
      this.setState({ filterStudentByName: nextProps.searchEsUserData.toJS() });
      // const results = nextProps.searchEsUserData;
      // results.forEach((fname) => {
      //   const grad = fname.get('academic');
      //   const sport = fname.get('sports');
      //   const position = sport.get('FOOTBALL');
      //   const obj = {};
      //   const name = fname.get('fullname');
      //   const city = fname.get('city');
      //   const state = fname.get('state');
      //   const studentid = fname.get('id');
      //   const email = fname.get('sa_email');
      //   const school = fname.get('school');
      //   const evaluationText = fname.get('evaluation_text');
      //   const overrideDivision = fname.get('override_division');
      //   const t40 = position.get('t40');
      //   const squats = position.get('squats');
      //   const bench = position.get('bench');
      //   const primaryOff = position.get('primary_offensive_position_pref');
      //   const primaryDef = position.get('primary_defensive_position_pref');
      //   const secondaryOff = position.get('secondary_offensive_position_pref');
      //   const secondaryDef = position.get('secondary_defensive_position_pref');
      //   const yearOfGraduation = grad.get('year_of_graduation');
      //   const gpa = grad.get('gpa');
      //   const id = fname.get('id');
      //   const idKey = studentid;
      //   obj.value = name;
      //   obj.student_id = studentid;
      //   obj.email = email;
      //   obj.state = state;
      //   obj.city = city;
      //   obj.school = school;
      //   obj.t40 = t40;
      //   obj.squats = squats;
      //   obj.bench = bench;
      //   obj.id = id;
      //   obj.gpa = gpa;
      //   obj.name = name;
      //   obj.primary_offensive_position_pref = primaryOff;
      //   obj.primary_defensive_position_pref = primaryDef;
      //   obj.secondary_offensive_position_pref = secondaryOff;
      //   obj.secondary_defensive_position_pref = secondaryDef;
      //   obj.overrideDivision = overrideDivision;
      //   obj.evaluationText = evaluationText;
      //   obj.year_of_graduation = yearOfGraduation;
      //   obj.Key = idKey;
      //   hits.push(obj);
      // });
      // this.setState({ fullNames: hits });
    }
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  searchAnotherStudent = () => {
    this.setState({
      username: '',
      errorMessage: '',
      name: '',
      student_id: '',
      key: '',
      email: undefined,
      school: '',
      evaluationText: '',
      overrideDivision: '',
      t40: '',
      squats: '',
      bench: '',
      primaryOff: '',
      primaryDef: '',
      secondaryOff: '',
      secondaryDef: '',
      id: '',
      studentfullname: '',
      fullNames: [],
      fullnameoncontact: '',
    });
  }

  searchStudent = () => {
    if (this.state.firstname === '' && this.state.lastname === '') {
      this.setState({ firstNameErrorMessage: 'Please enter a first name!',
        lastNameErrorMessage: 'Please enter a last name!',
      });
    } else {
      this.setState({ firstNameErrorMessage: '',
        lastNameErrorMessage: '',
      });
      const StudentFullName = this.state.firstname.concat(' ', this.state.lastname);
      let payload = {};
      payload = Object.assign({
        full_name: StudentFullName,
      });
      this.props.SearchAtheleteByName(payload);
    }
    this.setState({ errorMessage: '',
    });
  }
  render() {
    const { filterStudentByName } = this.state;
    const { searchEsUserRequested } = this.props;
    const renderLoader = renderIf(searchEsUserRequested === true);
    const renderSearchComponent = renderIf(true);
    const renderUserInfo = renderIf(true);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderSearchComponent(
          <div>
            <div className={cn('col s12 m4 l2', styles.removePaddingInnerDiv)}>
              <TextField
                label="ENTER FIRST NAME"
                onChange={val => this.handleChange('firstname', val)}
                value={this.state.firstname}
                errorMessage={this.state.firstNameErrorMessage}
              />
            </div>
            <div className={cn('col s12 m4 l2', styles.removePaddingInnerDiv)}>
              <TextField
                label="ENTER LAST NAME"
                onChange={val => this.handleChange('lastname', val)}
                value={this.state.lastname}
                errorMessage={this.state.lastNameErrorMessage}
              />
            </div>
            <div className={cn('col s12 m4 l2', styles.removePaddingInnerDiv)} style={{ marginTop: 5 }}>
              <div>
                <CustomButton
                  type="submit" label="SEARCH USER"
                  onClick={this.searchStudent}
                  style={styles.buttonContainer}
                />
                <Error message={this.state.errorMessage} />
              </div>
            </div>
          </div>,
          )}
        {renderLoader(
          <div className={cn('col s12', styles.removePadding)}>
            <FullScreenLoader />,
          </div>,
          )}
        {renderUserInfo(
          <div className={cn('col s12', styles.removePadding)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }} >
            {filterStudentByName.map(item => (
              <Tiles item={item} />
            ))}
          </div>
           ,
        )}
      </div>
    );
  }
}

export default SearchUserByFullName;



// WEBPACK FOOTER //
// ./src/components/SearchUserByFullName/SearchUserByFullName.js